// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Ox4Xg","wrapper_image":"styles_wrapper_image__GOAOE","wrapper_skeletone":"styles_wrapper_skeletone__UoceK"};